// Apply a preset DSL to the live store.

import { parseDsl } from '@/core/dsl';
import { migrate } from '@/core/migrate';
import { replaceState } from '@/core/state';
import type { Preset } from './presets';

export function loadPreset(p: Preset): boolean {
  const parsed = parseDsl(p.dsl);
  if (!parsed.ok) return false;
  const migrated = migrate(parsed.value);
  if (!migrated) return false;
  replaceState(
    {
      resolution: migrated.resolution,
      layers: migrated.layers,
      selectedLayerId: migrated.layers[0]?.id ?? null,
      soloLayerId: null,
      time: 0,
      paused: true,
      fps: 8,
    },
    true,
  );
  return true;
}
